import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";
import { queryClient } from "../../services/queryClient";

type Branch = {
  name: string;
  address: string;
  lga: string;
  state: string;
  countryCode: string;
  phoneNumber: string;
};

export const useCreateBranchesMutation = () => {
  const token = getToken();

  return useMutation({
    mutationFn: (payload: Branch) =>
      axiosInstance
        .post("/branches", payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["getBranches"] });
      // message.success(data?.message);
      // handleModalClose();
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
